<ng-container *ngIf="visible && value && value.srcData">
    <img [src]="value.srcData | resolveUrl | async" [alt]="alt" [height]="height" [width]="width"> 
</ng-container>
<ng-container *ngIf="visible && !(value && value.srcData)">
    <img src="./assets/images/photocamera-add.png" [alt]="alt" [height]="height" [width]="width">
</ng-container> 